import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'end-interview',
    templateUrl: './end-interview.component.html',
    standalone: false
})
export class EndInterviewComponent implements OnInit {

    instructions:any;

    constructor() {}

    ngOnInit() {

    }
}

